import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Allocate } from "../Allocate";
import { Filter } from "../Filter";
import { Publish } from "../Publish";
import { IAllRequirements } from "../../../models/AllRequirements";
import { IModel2 } from "../sales/TableAll";
import { format } from "date-fns";
import { IReqFilter, EmptyFilter } from "../Filter";
import { Dialog } from "primereact/dialog";
import { RejectReq } from "./RejectReq";
import { Tag } from "primereact/tag";
import { ReqQuery } from "../ReqQuery";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Submission } from "./Submission";
import { User } from "../../jvConnect/User";
import { Job_Type, Req_Term } from "../../../models/RequirementMast";

interface Iprops {
    toast: any
    permissions: IPermissionProps,
    reload: boolean,
    setReload: (is: boolean) => void,
    ShowCelebration: () => void
}

export const TablePublished = (props: Iprops) => {
    const [tableAllData, setTableAllData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [submission, setSubmission] = useState({ singleData: {}, open: false } as IModel2);
    const hideSubmissionDialog = () => {
        setSubmission({ singleData: {}, open: false });
    };
    const dt = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [allocation, setAllocation] = useState({ singleData: {}, open: false } as IModel2);
    const hideAllocationDialog = () => {
        setAllocation({ singleData: {}, open: false });
    };
    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const [query, setQuery] = useState({ req_id: 0, open: false } as { req_id: number, open: boolean });
    const hideQueryDialog = () => {
        setQuery({ req_id: 0, open: false });
    };
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean, rrreason: string | undefined, req_ID: number | undefined });
    const hideRRRDialog = () => {
        setRRR({ open: false, rrreason: "", req_ID: 0 });
    };
    const [rrrForm, setRRRForm] = useState({ open: false, req_ID: 0 } as { open: boolean, req_ID: number });
    const hideRRRFormDialog = () => {
        setRRRForm({ open: false, req_ID: 0 });
    };

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableAllData({ tableData: tableAllData.tableData, loading: true });
        const response = await Fetch("Requirement_MAST/getPublishReq", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + ``, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setTableAllData({
                tableData: data.map((rowData: any) => {
                    return { ...rowData, recruiter: (rowData.recruiter || "").split(',').map((ele: string) => (ele.trim().split("-")[0] + '-' + ele.trim().split("-")[1])).join(", ") }
                }), loading: false
            });
        } else setTableAllData({ tableData: tableAllData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center w-full">
            <h5 className="m-0">Published Requirements</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: null } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'DodgerBlue', color: 'white' }}>All</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "UnAllocated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'skyblue', color: 'white' }}>UnAlloc</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Implementing_Partner" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '8rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>Imp. Partner</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Served" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'green', color: 'white' }}>Served</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Unserved" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'yellow', color: 'black' }}>UnServed</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Rejected" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'red', color: 'white' }}>Rejected</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Updated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>Updated</div>
                    {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
                </div>
            </span>
        </div>
    );

    const req_ID = (rowData: IAllRequirements) => {
        return (!rowData.hold ?
            <span onClick={() => setSubmission({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_ID}
            </span>
            : <span>{rowData.req_ID}</span>);
    };
    const req_Job_Title = (rowData: IAllRequirements) => {
        return rowData.rejected_Status === "Yes" ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
                setRRR({ open: true, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID })
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="warning" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };
    const req_Hold_UnHoldStatus = (rowData: IAllRequirements) => {
        return rowData.hold ? "Hold" : "Unhold";

    };
    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const submission_id = (rowData: IAllRequirements) => {
        const countOfSubmissions = rowData.submission_id?.split(', ').length;
        const color = countOfSubmissions ? 'green' : rowData.recruiter ? 'yellow' : 'skyblue';
        return (<div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
            {_roles.includes(4) ? <span className="text-white">{rowData.submission_id}</span> : <span className="text-white">{countOfSubmissions}</span>}
        </div>);
    };
    const actionBodyTemplate = (rowData: IAllRequirements) => {
        return <>
            {_roles.includes(4) && <Button icon="pi pi-ban" label="Reject" className="p-button-rounded p-button-danger p-button-text" onClick={() => { if (rowData.req_ID) setRRRForm({ open: true, req_ID: rowData.req_ID }) }} />}
            <Button icon="pi pi-question-circle" label="Query" className="p-button-rounded p-button-text" onClick={() => { if (rowData.req_ID) setQuery({ open: true, req_id: rowData.req_ID }) }} />
        </>
    };
    const rowClass = (data: IAllRequirements) => {

        return {
            'bg-indigo-200 font-semibold': data.category === 1,
            'bg-gray-400': data.is_Duplicate === true,
            'bg-orange-100 font-semibold': data.reqType_ID === 1
        };
    }

    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={1} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableAllData.tableData} emptyMessage="No Requirements found."
                header={header} loading={tableAllData.loading}
                rowClassName={rowClass}>
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable body={req_ID} />
                <Column field="publish_Type" header="Published Type" sortable body={(rowData: any) => <p>{(rowData?.publish_Type === 1 ? "By Skill" : (rowData?.publish_Type === 2 ? "In Branch" : (rowData?.publish_Type === 3 ? "In Company" : (rowData?.publish_Type === 4 ? "Globally" : ""))))}</p>} />
                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IAllRequirements) => <User req={{
                        reqId: r.req_ID ?? '',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }}
                    />} />
                <Column field="salesCompany" header="Sales Comp(Branch)" />
                <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} sortable />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34))) && <Column field="client" sortable header="Client" />}
                <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
                {/* <Column field="pDate" header="Date" body={pDate} /> */}
                <Column field="pDate" style={{ minWidth: '100px' }} header="Date" body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DateFormat)} />
                {/* <Column field="recruiter" header="Recruiter" body={(rowData: any) => {
                    const recNames: string[] = (rowData?.recruiter?.trim() || "").split(",").map((elee: string) => `${elee.trim().split("-")[0]}-${elee.trim().split("-")[1]}`);
                    return rowData?.recruiter !== null ? <div>{recNames.map((elN: string) => <span>{elN},</span>)}</div> : <></>;
                }} /> */}
                <Column field="recruiter" header="Recruiter" />
                <Column field="hold" header="Status" body={req_Hold_UnHoldStatus} />
                <Column field="special_Constraint" header="Special Constraint" />

                <Column field="submission_id" header="Submittals" body={submission_id} style={{ maxWidth: "12rem" }} />
                <Column body={actionBodyTemplate} header="Action" />
            </DataTable>
            < Allocate roles={_roles} singleData={allocation.singleData} open={allocation.open} hideDialog={hideAllocationDialog} toast={props.toast} />
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={1} /> */}
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <Dialog visible={rrr.open} style={{ width: '80vw' }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
                <JVSunEditor value={rrr.rrreason} />
            </Dialog>
            <Submission singleData={submission.singleData} open={submission.open} hideDialog={hideSubmissionDialog} toast={props.toast} ShowCelebration={props.ShowCelebration} publish={true} />
            <ReqQuery open={query.open} req_id={query.req_id} hideDialog={hideQueryDialog} toast={props.toast} />
            <RejectReq open={rrrForm.open} req_id={rrrForm.req_ID} hideDialog={hideRRRFormDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} />
        </>
    );
}
